@if (variant === 'regular') {
  <span class="eas-loader" role="alert" aria-live="assertive" [attr.aria-label]="'common.loading' | translate">
    <span>
      @for (i of [0, 1, 2, 3]; track i) {
        <i [style.backgroundColor]="color"> </i>
      }
    </span>
  </span>
}
@if (variant === 'finger') {
  <div class="loading-indicator" [attr.brand]="brand" [attr.size]="size" aria-live="polite" aria-atomic="true" [attr.aria-label]="'common.loading' | translate">
    <div class="li-loader" aria-hidden="true" >
    </div>
  </div>
}
